const SlowInternetWarning = () => {
  return (
    <div className="bg-blue text-white p-4 text-center">
      La connexion Internet est lente ou vous n'êtes pas connecté à Internet.
      Veuillez vérifier votre connexion et actualiser la page.
    </div>
  );
};

export default SlowInternetWarning;
